import { gql } from '@apollo/client';

export const PUBLIC_API_PERMISSION_ITEM_FRAGMENT = gql`
  fragment PublicApiPermissionItemFields on PublicApiPermissionItem {
    resource
    operations
    children
    parent
  }
`;
